module.exports = __webpack_public_path__ + "static/media/D3Line.bacd78ee.png";